












































import { Component, Prop, Mixins } from 'vue-property-decorator';
import { ComponentProps, blogPath, Slides } from './types';
import ExtLink from '@/components/ext/Link.vue';
import ExtBtn from '@/components/ext/Button.vue';
import mixin from './../mixin';

@Component({
  components: {
    ExtLink,
    ExtBtn,
  },
})
export default class ComponentsPartsSliderHomepage extends Mixins(mixin)
  implements ComponentProps {
  // props
  @Prop({ type: String, default: 'Подробнее' })
  more: string;

  @Prop({ type: Object, default: null })
  path: blogPath;

  // computed
  get slides(): Slides {
    if (this.items && this.items.length > 0) {
      return this.items.map((item, index) => {
        return {
          more: this.more,
          ...item,
          curr: index === this.curr,
        };
      });
    }

    return [];
  }


  getEventType(slide: any) {
    const ret = this.$store.state.blogEventsDict.find((sprElem: any) => {
      return sprElem.id === slide.event_type;
    });
    if (ret) {
      return ret.name;
    }
    return '';
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/slider/homepage/Homepage.vue